import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../../icons/Icon';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistReasonModalComponent extends Component<Props> {
  render() {
    const { visible, onClose } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'custom-dialog w-2/5 h-auto'}
        visible={visible}
        onHide={onClose}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  private getHeader = () => {
    return (
      <div className={'bg-[#F9FAFB] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-4'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-x-2'}>
          <Icon icon={'kyc_remarksicon'} className={'text-[#4F4F4F] fill-f-black-2'} size={18} />
          <div className={'text-f-black-2 font-normal text-md'}>{LanguageUtil.get({ id: 'common.label.reason' })}</div>
        </div>
      </div>
    );
  };

  private getContent = () => {
    const { reason } = this.props;
    return <div className={'h-full w-full p-4 m-0'}>{reason}</div>;
  };
}

interface Props {
  visible: boolean;
  reason: string | undefined;
  onClose: () => void;
}

export default WatchlistReasonModalComponent;
